import React, { useMemo } from 'react';
import { BadgeAvatar, HelperTooltip } from '@/components';

import { Badge } from '@/views/Badge';

import style from './index.module.scss';
import cx from 'clsx';

export const Badges = ({ data, className }: { data: Badge[]; className?: string }) => {
  const badges = useMemo(() => data?.slice(0, 3), [data]);

  if (!badges?.length) {
    return null;
  }

  return (
    <div className={cx(style.badgeList, className)}>
      {badges.map(item => {
        return (
          <HelperTooltip key={item.id} title={item.name} placement="bottomLeft" inParent>
            <BadgeAvatar src={item.logo_thumbnail_url} className={style.badgeIcon} width={38} />
          </HelperTooltip>
        );
      })}
    </div>
  );
};
